
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.70711 21.3473C3.31658 21.7378 2.68342 21.7378 2.29289 21.3473C1.90237 20.9568 1.90237 20.3236 2.29289 19.9331L9.39356 12.8324C8.51838 11.6638 8 10.2126 8 8.64032C8 4.77434 11.134 1.64034 15 1.64034C18.866 1.64034 22 4.77434 22 8.64032C22 12.5063 18.866 15.6403 15 15.6403C13.4276 15.6403 11.9763 15.1219 10.8078 14.2466L6.66421 18.3902L8.92657 20.6525C9.31709 21.0431 9.31709 21.6762 8.92657 22.0668C8.53604 22.4573 7.90288 22.4573 7.51235 22.0668L5.24999 19.8044L3.70711 21.3473ZM15 3.64034C12.2386 3.64034 10 5.87891 10 8.64032C10 11.4017 12.2386 13.6403 15 13.6403C17.7614 13.6403 20 11.4017 20 8.64032C20 5.87891 17.7614 3.64034 15 3.64034Z","fill":"#16171F"}})])
          )
        }
      }
    